import { useCallback, useEffect, useState } from 'react';

import Image from 'next/image';

import { Text } from '@olist/united';

import { Container } from 'modules/components/Container';
import { Footer } from 'modules/components/Footer';
import { FormContainer } from 'modules/components/Login/FormContainer';
import { gtag } from 'utils/gtag';

import Logo from '../../../../public/olist.svg';
import { Form } from './Form';
import { Success } from './Success';

import type { NextPage } from 'next';

export const ResetPassword: NextPage = () => {
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    gtag('set', {
      page_title: 'Esqueci minha senha',
    });
  });

  const onSuccess = useCallback((resetEmail: string) => {
    setEmail(resetEmail);
    setSuccess(true);
  }, []);

  return (
    <Container>
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          padding: '0px 16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '56px 0px 32px',
          }}
        >
          <Image alt="Olist" src={Logo} width={120} height={70} />
        </div>
        <FormContainer>
          <Text.H3 textAlign="center">
            {!success ? 'Esqueceu a senha?' : 'Confira seu email'}
          </Text.H3>
          {!success ? <Form onSuccess={onSuccess} /> : <Success email={email} />}
        </FormContainer>
      </div>
      <Footer />
    </Container>
  );
};
